import React from 'react';
import { CustomDialog } from '../CustomDialog';
import { useEvent } from '../../hooks/useEvent';
import { EventType } from '../../services/Types';

interface DialogApproveEventProps {
  eventId: number; // event id to approve
  onSuccess: () => void;  // Callback to refresh events list after approval
  onCancel: () => void; // Callback to close the dialog
}

export const DialogApproveEvent: React.FC<DialogApproveEventProps> = ({ eventId, onSuccess, onCancel }) => {
  const { handleApproveEvent, updating, eventData } = useEvent();

  const handleApprove = async () => {
    const success = await handleApproveEvent(eventId);
    if (success) {
      onSuccess();
    }
    onCancel();
  };

  // Get event type from cache for button text
  const approveText = eventData?.eventType === EventType.SERIES ? "Approve All" : "Approve";

  return (
    <CustomDialog
      title="Are you sure you want to approve this event?"
      primaryButtonText={`Yes, ${approveText.toLowerCase()} this event`}
      secondaryButtonText="Cancel"
      open={true}
      onClose={onCancel}
      onPrimaryButtonClick={handleApprove}
      onSecondaryButtonClick={onCancel}
      disablePrimaryButton={updating}
    />
  );
}; 